module.exports = __webpack_public_path__ + "img/weixin-qr.a610775f.png";